import React, { useState } from 'react'
import { MultiSelect as KMultiSelect, MultiSelectChangeEvent } from '@progress/kendo-react-dropdowns';
import { Label } from '@progress/kendo-react-labels';
import './MultiSelect.scss';

interface IMultiSelectProps {
  data: any;
  label: string;
  onChange: (data: any) => void;
  dataKey: string;
  textfield: string;
  size?: 'small' | 'medium' | 'large';
  fullwidth?: boolean;
  placeholder?: string;
  required?: boolean;
  values?: any;
  disabled?: boolean;
}

/**
 *
 * @param data any[]
 * @param label string - label of the multiselect
 * @param onChange (data: any) => void - function to accept array of data containing selected items
 * @param dataKey string - name of the field containing the unique identifier typically ID
 * @param textfield string - name of the data field you want to display in the multiselect dropdown
 * @param size 'small' | 'medium' | 'large' - determines width of the component
 * @param fullwidth boolean - overrides the size param
 * @param placeholder string - default text appearing in the multiselect bar
 * @param required boolean - shows required labels on component
 * @example
 * <MultiSelect
      label={'Draft Select'}
      data={[{id: 1, draftName: 'test'}]}
      onChange={(data:any) => { console.log(data)}}
      dataKey={'id'}
      textfield={'draftName'}
      size="large"
      required={true}
    />
 * @returns React.Component
 */
const MultiSelect = (props: IMultiSelectProps) => {
  const { data, onChange, size, fullwidth, placeholder, dataKey, textfield, required, label, values, disabled } = props;
  const [value, setValue] = useState<any[]>(values ?? []);
  const [style] = useState<string>(fullwidth ? '100%' : size === 'large' ? '60%' : size === 'medium' ? '40%' : '30%');

  const handleChange = (event: MultiSelectChangeEvent) => {
    setValue([...event.value]);
    onChange([...event.value]);
  }

  return (
    <div className="multi-select">
      {label ? (
        <Label className={required ? 'k-required' : ''}>Select {label}</Label>
      ) : null}
      <KMultiSelect
        data={data}
        value={values ?? value}
        dataItemKey={dataKey}
        onChange={handleChange}
        style={{ width: style }}
        placeholder={placeholder ?? ''}
        textField={textfield}
        required={required ?? false}
        disabled={disabled}
      />
    </div>
  )
}

export default MultiSelect